






















































































import Vue, { PropType } from 'vue'
import { DashboardTemplate } from '../../base/store/state.interface'
import { PermutatorService } from '../widgets/base/permutator'

import BaseDialog from './BaseDialog.vue'
import BaseSelect from '../../base/components/BaseSelect.vue'
import BaseCheckbox from '../../base/components/BaseCheckbox.vue'
import BaseInput from '../../base/components/BaseInput.vue'
import WidgetContainerFactory from '../widgets/container/WidgetContainerFactory'

export default Vue.extend({
  components: {
    BaseDialog,
    BaseSelect,
    BaseInput,
    BaseCheckbox
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    currentAlarmDashboardTemplate: {
      type: Object as PropType<DashboardTemplate>,
      required: true,
    }
  },
  data() {
    return {
      operationsDurationOptions: [
        {label: 'bis Einsatz geschlossen oder archiviert', value: null},
        {label: '1 Minute', value: 1},
        {label: '2 Minuten', value: 2},
        {label: '3 Minuten', value: 3},
        {label: '5 Minuten', value: 5},
        {label: '10 Minuten', value: 10},
        {label: '15 Minuten', value: 15},
        {label: '30 Minuten', value: 30},
        {label: '60 Minuten', value: 60},
        {label: '90 Minuten', value: 90},
        {label: '2 Stunden', value: 120}
      ]
    }
  },
  computed: {
    availableTemplates() {
      const availableTemlates = this.$store.state.dashboard?.templates || []
      let templates = JSON.parse(JSON.stringify(availableTemlates)) as Array<DashboardTemplate>

      templates.sort((a,b) => (a.title < b.title) ? -1 : (a.title > b.title) ? 1 : 0)

      return templates
    },
    currentSelectedAlarmDashboardTemplate() {
      return this.currentAlarmDashboardTemplate.title || 'Kein Alarm Dashboard'
    },
    availableTemplatesNames() {
      return ['Kein Alarm Dashboard', ...this.availableTemplates.map(elem => elem.title)]
    }
  },
  methods: {
    selectAlarmDashboardId(dashboardTitle: string) {
      let dashboardId = this.availableTemplates.filter(elem => elem.title === dashboardTitle)[0]?.id || null
      this.$emit('setAlarmDashboardId', dashboardId)
    }
  }
})

